import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    signUps: 0,
    communityPost: 0,
    moodsLogged: 0,
    thoughtsLogged: 0,
    totalUser: 0,
    male: 0,
    female: 0,
    community: 0,
    logMood: 0,
    logThoughts: 0,
    journaling: 0,
    affirmation: 0,
    innerCircleCount: 0,
    encouragementGroupCount: 0,
    moodsData: null,
    thoughtsData: null,
    postActivityData: null,
    wellnessActivityData: null,
    averageData: null,
    wellnessChartData: null,
    whoScoreData: [],
    whoAssessmentSuccess: false,
    lastReqAssesmentData: {},
    affirmationData: [],
    therapyData: [],
    journalData: [],
    upcomingAssessmentDate: null,
    whoScoreSuccess : null

};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        dashboardLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        dashboardSuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.signUps = action.payload.data[0].signUps;
            state.communityPost = action.payload.data[0].communityPost;
            state.moodsLogged = action.payload.data[0].moodsLogged;
            state.thoughtsLogged = action.payload.data[0].thoughtsLogged;
        },
        dashboardFailed: state => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = true;
        },
        signupsLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        signupsSuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.totalUser = action.payload.data[0].totalUser;
            state.male = action.payload.data[0].male;
            state.female = action.payload.data[0].female;
        },
        signupsFailed: state => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = true;
        },
        topUsageLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        topUsageSuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.community = action.payload.data[0].community;
            state.logMood = action.payload.data[0].logMood;
            state.logThoughts = action.payload.data[0].logThoughts;
            state.journaling = action.payload.data[0].journaling;
            state.affirmation = action.payload.data[0].affirmation;
            state.innerCircleCount = action.payload.data[0].circle;
            state.encouragementGroupCount = action.payload.data[0].allGroup;


        },
        topUsageFailed: state => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = true;
        },
        moodsLoggedLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        moodsLoggedSuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.moodsData = action.payload.data;
        },
        moodsLoggedFailed: state => {
            state.isLoading = false;
            state.isSuccess = false;
        },
        thoughtsLoggedLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        thoughtsLoggedSuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.thoughtsData = action.payload.data;
        },
        thoughtsLoggedFailed: state => {
            state.isLoading = false;
            state.isSuccess = false;
        },
        postActivityLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
        },
        postActivitySuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.postActivityData = action.payload.data;
        },
        postActivityFailed: state => {
            state.isLoading = false;
            state.isSuccess = false;
        },
        wellnessActivityLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
        },
        wellnessActivitySuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.wellnessActivityData = action.payload.data;
        },
        wellnessActivityFail: state => {
            state.isLoading = false;
            state.isSuccess = false;
        },
        averageMoodLoad: state => {
            state.isLoading = true;
            state.isSuccess = false;
        },
        averageMoodSuccess: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.averageData = action.payload.data;
        },
        averageMoodFail: state => {
            state.isLoading = false;
        },
        wellnessChartLoad: state => {
            state.isLoading = true;
        },
        wellnessChartSuccess: (state, action) => {
            state.isLoading = false;
            state.wellnessChartData = action.payload;
        },
        wellnessChartFail: state => {
            state.isLoading = false;
        },
        getWhoScoreLoad: state => {
            state.isLoading = true;
        },
        getWhoScoreSuccess: (state, action) => {
            state.isLoading = false;
            state.whoScoreData = action.payload;
        },

        getWhoScoreFail: state => {
            state.isLoading = false;
        },
        requestScoreLoad: state => {
            state.isLoading = true
            state.whoAssessmentSuccess = true
            state.whoScoreSuccess = false
        },
        
        editrequestScoreLoad: state => {
            state.isLoading = true
            state.whoAssessmentSuccess = false
        },
        requestScoreSuccess: (state, action) => {
            state.isLoading = false
            state.lastReqAssesmentData = action.payload
            state.whoAssessmentSuccess = true
            state.whoScoreSuccess = true
        },
        requestScoreFail: state => {
            state.isLoading = false;
            state.whoAssessmentSuccess = false;
            state.whoScoreSuccess = false
        },

        getAffirmationLoad: (state) => {
            state.isLoading = true;
        },

        getAffirmationSuccess: (state, action) => {
            state.isLoading = false;
            state.affirmationData = action.payload[0].allAffirmation;
        },

        getJournalLoad: state => {
            state.isLoading = true;

        },

        getJournalSuccess: (state, action) => {
            state.isLoading = false;
            state.journalData = action.payload[0].allJournal;
        },
        getTherapyload: state => {
            state.isLoading = true;
        },
        getTherapySuccess: (state, action) => {
            state.isLoading = false;
            state.therapyData = action.payload[0].allTherapy;
        },

        upcomingAssessmentLoad: (state, action) => {
            state.isLoading = false;
        },
        upcomingAssessmentSuccess: (state, action) => {
            state.isLoading = false;
            state.upcomingAssessmentDate = action.payload;
        },
        upcomingAssessmentFail: (state, action) => {
            state.isLoading = false;
            state.upcomingAssessmentDate = null;
        }
    },
});

export const {
    dashboardLoad,
    dashboardSuccess,
    dashboardFailed,
    signupsLoad,
    signupsSuccess,
    signupsFailed,
    topUsageLoad,
    topUsageSuccess,
    topUsageFailed,
    moodsLoggedLoad,
    moodsLoggedSuccess,
    moodsLoggedFailed,
    thoughtsLoggedLoad,
    thoughtsLoggedSuccess,
    thoughtsLoggedFailed,
    postActivityLoad,
    postActivitySuccess,
    postActivityFailed,
    wellnessActivityLoad,
    wellnessActivitySuccess,
    wellnessActivityFail,
    averageMoodLoad,
    averageMoodSuccess,
    averageMoodFail,
    wellnessChartLoad,
    wellnessChartSuccess,
    wellnessChartFail,
    getWhoScoreFail,
    getWhoScoreLoad,
    getWhoScoreSuccess,

    requestScoreLoad,
    editrequestScoreLoad,
    requestScoreSuccess,
    requestScoreFail,

    getAffirmationLoad,
    getAffirmationSuccess,
    getJournalLoad,
    getJournalSuccess,
    getTherapyload,
    getTherapySuccess,
    upcomingAssessmentLoad,
    upcomingAssessmentSuccess,
    upcomingAssessmentFail

} = dashboardSlice.actions;

export default dashboardSlice.reducer;
